export default __webpack_public_path__ + "static/media/dg1.cac9e8ef.jpg";